export default function ComparisonSection() {
  const rows = [
    { feature: "Product Discovery", spreadsheet: "Structured spreadsheet lists", normal: "Manual search" },
    { feature: "Price Comparison", spreadsheet: "Built-in comparison tables", normal: "Not available" },
    { feature: "Agent Access", spreadsheet: "Direct verified agents", normal: "Random sellers" },
    { feature: "Risk Level", spreadsheet: "Lower (curated lists)", normal: "Higher" },
    { feature: "Efficiency", spreadsheet: "Very fast", normal: "Slow" },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold text-secondary-600 uppercase tracking-widest">
            Why Choose Us
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mt-3 leading-tight">
            Why Use ItaobuySpreadsheet
            <br />
            Instead of Traditional Shopping?
          </h2>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-background-300/60">
                <th className="text-left py-4 px-5 text-sm font-semibold text-foreground-700">Feature</th>
                <th className="text-left py-4 px-5 text-sm font-semibold text-secondary-600">
                  <span className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-secondary-500"></i>
                    ItaobuySpreadsheet
                  </span>
                </th>
                <th className="text-left py-4 px-5 text-sm font-semibold text-foreground-500">
                  Normal Shopping
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.feature} className="border-b border-background-200/70 hover:bg-background-50 transition-colors">
                  <td className="py-4 px-5 text-sm font-medium text-foreground-800">{row.feature}</td>
                  <td className="py-4 px-5 text-sm text-foreground-700">
                    <span className="flex items-center gap-2">
                      <i className="ri-check-line text-secondary-500"></i>
                      {row.spreadsheet}
                    </span>
                  </td>
                  <td className="py-4 px-5 text-sm text-foreground-500">{row.normal}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}